import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable, catchError, finalize, of, tap } from 'rxjs';
import { UserService } from '../user-service/user-service';
import { AuthService } from '@/app/features/pre-login/services/login-service/auth-service';
import { UserModel } from '../../models/UserModels/UserModel';
import { ProjectTeamMemberService } from '@/app/features/post-login/services/project-team-member-service/project-team-member-service';
import { LoaderService } from '../loader-service/loader-service';
import { AutoLogoutService } from '../auto-logout-service/auto-logout-service';

@Injectable({
  providedIn: 'root',
})
export class UserResolver {
  constructor(
    private authService: AuthService,
    private userService: UserService,
    private loader: LoaderService,
    private autoLogoutService: AutoLogoutService
  ) {}

  resolve(route: ActivatedRouteSnapshot): Observable<UserModel | null> {
    return this.userService.loadUser().pipe(
      finalize(() => {
        setTimeout(() => this.loader.hide(), 1500);
        this.autoLogoutService.startTracking();
      })
    );
  }
}
